import { defineComponent as _defineComponent } from 'vue'
import "vue3-carousel/dist/carousel.css";
  import { Carousel, Slide, Navigation, Pagination } from "vue3-carousel";
  import {
    ref,
    computed,
    watch,
    onMounted,
  } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import HouseCard from "@/components/builder/budget-houses/HouseCard.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { BuilderQuote } from "@/types/BuilderQuote";
  import { BorrowCalculatorResult } from "@/types/BorrowCalculator";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import { formatPrice } from "@/helpers/transformation/price";
  import store from "@/store";
  import { FacadeInterface } from "@/types/FacadeInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderSliderMobile',
  props: {
    selectedHouseDesign: Object as () => HouseDesignInterface | undefined,
    isOpen: Boolean,
    isCardHouseDesign: Boolean,
    houses: {
      type: Array as () => HouseDesignInterface[],
      default: () => [] as HouseDesignInterface[],
    },
    estate: Object as () => EstateInterface | undefined,
    quote: Object as () => BuilderQuote | undefined,
    result: Object as () => BorrowCalculatorResult | undefined,
    houseDetailsView: Boolean,
  },
  emits: ["update:selectedFacade"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;

  const currentSlideIndex = ref(0);
  const lastSlideIndex = ref(0);
  const selectedFacadeId = ref<string | null>(null);
  const selectedFacadeIds = ref<{ [key: string]: boolean }>({});
  const facadeDefault = ref<FacadeInterface | null>(null);

  const getSliderNavigation = computed(() => {
    return (
      props.houses.length > 1 ||
      (props.selectedHouseDesign &&
        props.selectedHouseDesign.facades.length > 1)
    );
  });

  const isNoAdditionalCharge = (price: number | null | undefined | string) => {
    return (
      price === 0 || price === null || price === undefined || price === "0"
    );
  };

  watch(
    () => props.isOpen,
    (newVal) => {
      if (!newVal) {
        lastSlideIndex.value = currentSlideIndex.value;
      } else {
        currentSlideIndex.value = lastSlideIndex.value;
      }
    },
    { immediate: true }
  );

  const updateSelectedFacade = (facade: FacadeInterface, value: boolean) => {
    if (!value && facadeDefault.value?._id) {
      selectedFacadeIds.value[facadeDefault.value._id] = true;
      emits("update:selectedFacade", facadeDefault.value);
    } else if (selectedFacadeId.value) {
      selectedFacadeIds.value[selectedFacadeId.value] = false;
      selectedFacadeId.value = facade._id;
      emits("update:selectedFacade", facade);
    }

    selectedFacadeIds.value[facade._id] = value;
  };

  const initializeFacades = (design: HouseDesignInterface) => {
    let defaultFacade = design.facades.find(
      (facade) =>
        props.quote && facade.url === props.quote.selections.facade.url
    );

    if (!defaultFacade) {
      defaultFacade = design.facades[0];
    }

    if (defaultFacade) {
      facadeDefault.value = defaultFacade;
      design.facades.forEach((facade) => {
        selectedFacadeIds.value[facade._id] = facade._id === defaultFacade?._id;
      });
      selectedFacadeId.value = defaultFacade._id;
      emits("update:selectedFacade", defaultFacade);
    }
  };

  watch(
    () => props.selectedHouseDesign,
    (newDesign) => {
      if (newDesign) {
        initializeFacades(newDesign);
      }
    },
    { immediate: true }
  );

  onMounted(() => {
    if (props.selectedHouseDesign) {
      initializeFacades(props.selectedHouseDesign);
    }
  });

const __returned__ = { props, emits, currentSlideIndex, lastSlideIndex, selectedFacadeId, selectedFacadeIds, facadeDefault, getSliderNavigation, isNoAdditionalCharge, updateSelectedFacade, initializeFacades, get Carousel() { return Carousel }, get Slide() { return Slide }, get Navigation() { return Navigation }, get Pagination() { return Pagination }, ref, computed, watch, onMounted, get HouseDesignInterface() { return HouseDesignInterface }, HouseCard, get EstateInterface() { return EstateInterface }, get BuilderQuote() { return BuilderQuote }, get BorrowCalculatorResult() { return BorrowCalculatorResult }, ToggleButton, get formatPrice() { return formatPrice }, get store() { return store }, get FacadeInterface() { return FacadeInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})